import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAxiosInterceptor } from "src/hooks/useAxiosInterceptor";
import { GRAPHQL_ENDPOINT } from "src/constants/endpoints";
import { UPDATE_MODIFIER_CATEGORY } from "src/constants/mutations";
import { failureToast, successToast } from "src/utils/toasts";
import { UUID } from "src/types/shared.type";
import { RootState } from "src/store/index";
import { remove_modifier_category, set_delete_modal_category_id } from "src/store/features/modifier-categories-slice";
import { UpdateModifierCategoryInput } from "src/interfaces/modifier.interface";

export const useDeleteModifierCategory = () => {
  const dispatch = useDispatch();
  const { axBe } = useAxiosInterceptor();

  const [isDeletingModifierCategory, setIsDeletingModifierCategory] = useState(false);
  const { toBeDeletedModifierCategoryId } = useSelector(
    (state: RootState) => state.modifierCategories
  );

  const deleteModifierCategoryMutation = useCallback(
    async () => {

      if (!toBeDeletedModifierCategoryId) {
        console.error("Cannot delete: No modifier category ID provided");
        return;
      }
        
      setIsDeletingModifierCategory(true);
      try {
        const variables: {updateModifierCategoryInput: UpdateModifierCategoryInput} = {
          updateModifierCategoryInput: {
            modifierCategoryCorrelationId: toBeDeletedModifierCategoryId,
            isActive: false,
          },  
        };
        const { data } = await axBe.post(GRAPHQL_ENDPOINT, {
          query: UPDATE_MODIFIER_CATEGORY,
          variables,
        });

        if (data?.data?.updateModifierCategory) {
          // Remove the category from Redux state
          dispatch(remove_modifier_category(toBeDeletedModifierCategoryId));
          dispatch(set_delete_modal_category_id(null));
          successToast("Modifier category has been deleted successfully!");
        }
      } catch (err) {
        console.error("Error deleting modifier category:", err);
        const errorMessage = "Failed to delete modifier category";
        failureToast(errorMessage);
      } finally {
        setIsDeletingModifierCategory(false);
      }
    },
    [axBe, dispatch, toBeDeletedModifierCategoryId]
  );

  const handleOpenDeleteModal = useCallback((correlationId: UUID) => {
    dispatch(set_delete_modal_category_id(correlationId));
  }, [dispatch]);

  const handleCloseDeleteModal = useCallback(() => {
    dispatch(set_delete_modal_category_id(null));
  }, [dispatch]);

  return {
    isDeletingModifierCategory,
    deleteModifierCategoryMutation,
    handleOpenDeleteModal,
    handleCloseDeleteModal,
  };
};
